import { render, staticRenderFns } from "./QuizSubject.vue?vue&type=template&id=76f11894&"
import script from "./QuizSubject.vue?vue&type=script&lang=js&"
export * from "./QuizSubject.vue?vue&type=script&lang=js&"
import style0 from "./QuizSubject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports